module.exports = __webpack_public_path__ + "img/Weapon_75.2555ae37.png";